import { render, staticRenderFns } from "./header.vue?vue&type=template&id=7537ab0f&scoped=true&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style0 from "@/assets/main.css?vue&type=style&index=0&id=7537ab0f&scoped=true&lang=css&"
import style1 from "./header.vue?vue&type=style&index=1&id=7537ab0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7537ab0f",
  null
  
)

export default component.exports